import client from '/src/services/client.js';

export default {
   
    addStatement : (name, data)=> client.post(`dataset/${name}/statement`, data),
    updateStatement : (name, id, data)=> client.put(`dataset/${name}/statement/${id}`, data),
    deleteStatement : (name, id)=> client.delete(`dataset/${name}/statement/${id}`),
    importStatement : (name, data)=> client.post(`dataset/${name}/import`, data),
    importStopWords : (name, data) => client.post(`dataset/${name}/update/stop-words`, data),
    exportStatements : (name) => client.get(`dataset/${name}/export`),
    deleteAllStatements : (name) => client.delete(`dataset/${name}/statements`),
    searchResponse : (name, question) => client.post(`dataset/${name}/question`, question),

}